import { PrivacyPage } from "@/pages/";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_unauthenticated/privacy")({
  component: PrivacyPage,
});
